import { injectable, inject } from 'inversify';

import { History } from '@vk-hr-tek/core/history';

import { BellNotificationsRouter } from '../../../bell-notifications/types';
import { modules } from '../../modules';

@injectable()
export class BellNotificationsRouterService implements BellNotificationsRouter {
  constructor(@inject(History) private history: History) {}

  goToNotificationsPage() {
    this.history.push(`/${modules.bell_notifications.basename}`);
  }
}
